import React from 'react';
import { Link } from 'react-router-dom';

// Core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';

// @material-ui core components
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from 'components/CustomButtons/Button.jsx';

const VendorForms = ({ classes, vendorSelected, driverSelected, vendorId, driverId, vendorsData, driversData, handleVendorChange, handleSelectChange }) => {
    const vendor = vendorSelected ? vendorSelected : '';
    const driver = driverSelected ? driverSelected : '';

    return (
        <GridItem xs={12}>
            <GridContainer>
                <GridItem xs={3}>
                    <FormControl fullWidth className={classes.selectFormControl}>
                        <InputLabel
                            htmlFor="vendorSelected"
                            className={classes.selectLabel}
                        >
                            Vendors:
                        </InputLabel>
                        <Select
                            MenuProps={{
                                className: classes.selectMenu,
                            }}
                            classes={{
                                select: classes.select,
                            }}
                            value={vendorSelected ? vendorSelected : ''}
                            onChange={handleVendorChange}
                            inputProps={{
                                id: 'vendorSelected',
                                name: 'vendorSelected',
                            }}
                            required
                        >
                            {vendorsData.map(v => v.name).map((vendor, i) => (
                                <MenuItem
                                    classes={{
                                        root: classes.selectMenuItem,
                                    }}
                                    value={vendor}
                                    key={i}
                                >
                                    {vendor}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    {vendorSelected && (
                        <GridItem xs={3}>
                            <Link to={`/vendor/${vendorId}`}>
                                <Button color="info">Go to Vendor</Button>
                            </Link>
                        </GridItem>
                    )}
                </GridItem>
                <GridItem xs={3}>
                    <FormControl fullWidth className={classes.selectFormControl}>
                        <InputLabel
                            htmlFor="driver"
                            className={classes.selectLabel}
                        >
                            Drivers:
                        </InputLabel>
                        <Select
                            MenuProps={{
                                className: classes.selectMenu,
                            }}
                            classes={{
                                select: classes.select,
                            }}
                            value={driverSelected}
                            onChange={handleSelectChange}
                            inputProps={{
                                id: 'driverSelected',
                                name: 'driverSelected',
                            }}
                        >
                            {driversData.map(d => d.name).map((driver, i) => (
                                <MenuItem
                                    classes={{
                                        root: classes.selectMenuItem,
                                    }}
                                    value={driver}
                                    key={i}
                                >
                                    {driver}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    {driverSelected && (
                        <GridItem xs={3}>
                            <Link to={`/user/${driverId}`}>
                                <Button color="info">Go To Driver</Button>
                            </Link>
                        </GridItem>
                    )}
                </GridItem>
            </GridContainer>
        </GridItem>
    )
}

export default VendorForms;


// WEBPACK FOOTER //
// ./src/components/Forms/TripVendorForm.jsx